import LinkInBio from "@/models/LinkInBio";

const state={
    transientLinkInBio: new LinkInBio({id:""})
};

const getters={
    transientLinkInBio: state => state.transientLinkInBio,
};

const actions={
   
    setTransientLinkInBio({commit}, linkInBio){
        commit("setTransientLinkInBio", linkInBio);
    }
};

const mutations={
    setTransientLinkInBio: (state, linkInBio) => {
        state.transientLinkInBio = linkInBio;
    }
};


export default {
    state,
    getters,
    actions,
    mutations
}
